import type { CopyLocale, LocalizedCopy } from './registry';

export type OverrideMap = Record<string, Partial<Record<CopyLocale, string>>>;

export function buildOverrideMap(
  rows: { key: string; locale: CopyLocale; value: string }[],
): OverrideMap {
  const map: OverrideMap = {};
  for (const row of rows) {
    (map[row.key] ??= {})[row.locale] = row.value;
  }
  return map;
}

export function resolveCopy(
  overrides: OverrideMap,
  key: string,
  fallback: LocalizedCopy,
  locale: CopyLocale,
): string {
  return overrides[key]?.[locale] || fallback[locale] || fallback.es || '';
}

export function extractVars(input: string): string[] {
  const found = new Set<string>();
  for (const match of input.matchAll(/\{(\w+)\}/g)) {
    found.add(match[1]);
  }
  return [...found].sort();
}
